"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dayPassReportPageActions;
(function (dayPassReportPageActions) {
    dayPassReportPageActions["BoldReportsViewerLoaded"] = "BoldReportsViewerLoaded";
})(dayPassReportPageActions || (dayPassReportPageActions = {}));
exports.default = dayPassReportPageActions;
